module.exports = __webpack_public_path__ + "img/caret-square-right.7d498061.svg";